module.exports = __webpack_public_path__ + "media/assets/images/pluga-logo-3e27d930f602413bfbc2c579a2901cc6.svg";